import axios from "axios";
import moment from "moment";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  getPromoteurs,
  handleSyncPromoteur,
  updateSinglePromoteur,
} from "../../../redux/actions/promoteursActions";

const SinglePromoteurCard = ({
  imgUrl,
  title,
  nbrProgrammes,
  nbrLots,
  original_id,
  lastSync,
  user,
}) => {
  const token = localStorage.getItem("token");
  const [syncLoading, setSyncLoading] = useState(false);
  const dispatch = useDispatch();

  const updatePromoteur = async (id) => {
    setSyncLoading(true);
    dispatch(handleSyncPromoteur(id));
    setSyncLoading(false);
  };

  return (
    <div className="bg-white px-20 py-10">
      <div className="d-flex gap20 radius5">
        <img src={imgUrl} alt="" height={110} width={110} className="radius5" />
        <div className="darkGrey d-flex flex-column justify-content-center">
          <p className="fs16 semibold line-clamp-2">{title}</p>
          <p className="fs11 regular">{nbrProgrammes} programmes</p>
          <p className="fs11 semibold mt-20">{nbrLots} lots</p>
        </div>
      </div>
      <div className="separator mb-10"></div>
      <div className="d-flex  justify-content-between align-items-center">
        <div className="d-flex flex-column">
          {" "}
          <span className="fs11">Date de la mise à jour</span>
          <span className="fs11 regular">
            {moment().diff(lastSync, "minutes") < 1
              ? "À l'instant"
              : moment(lastSync).format("DD/MM/YYYY HH:mm")}
          </span>
        </div>
        <button
          className={
            !syncLoading && user.updateCatalogue
              ? "fs13 regular radius5 px-20 py-10 bg-pink text-white border-0"
              : "fs13 regular radius5 px-20 py-10 bg-soft-grey text-white border-0 pointer-none"
          }
          onClick={() => updatePromoteur(original_id)}
          disabled={syncLoading || !user.updateCatalogue}
          title={
            !user.updateCatalogue
              ? "Vous n'avez pas le droit de synchroniser"
              : ""
          }
        >
          {syncLoading ? "En Cours..." : "Synchroniser"}
        </button>
      </div>
    </div>
  );
};

export default SinglePromoteurCard;
